import { Modal, ModalBody, ModalContent } from "@nextui-org/react"
import { isDesktop } from "react-device-detect"
import VIP from "views/Vip"

function VipCardModalV2({ isOpen, setIsOpen }) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(!isOpen)}
      size={isDesktop ? "" : "full"}
      scrollBehavior="inside"
      hideCloseButton
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalBody>
              <VIP />
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default VipCardModalV2
